import type { Me, RoleNames } from "@getaways/extranet-ui";
import { createContext, useContext } from "react";

/** Mirrors toursAccess in @getaways/tours: what each role may do, so the pages can hide actions. */
const PERMISSIONS: Record<string, string[]> = {
  admin: ["booking:read", "booking:manage", "refund:manage", "catalogue:manage", "settings:manage", "reconciliation:manage", "users:manage"],
  operations: ["booking:read", "booking:manage", "refund:manage", "catalogue:manage", "reconciliation:manage"],
  read_only: ["booking:read"],
};

export type Permission = "booking:read" | "booking:manage" | "refund:manage" | "catalogue:manage" | "settings:manage" | "reconciliation:manage" | "users:manage";

export const ROLE_NAMES: RoleNames = { admin: "Administrator", operations: "Operations", read_only: "Read only" };

/** Every back-office role belongs to the Ideastation operator organization. */
export const rolesFor = () => ["admin", "operations", "read_only"];

export const canWith = (me: Me, permission: Permission) => me.user.memberships.some((m) => PERMISSIONS[m.role]?.includes(permission));

export const MeContext = createContext<Me | undefined>(undefined);

/** Whether the signed-in user may do this; the API checks again on every request. */
export function useCan(): (permission: Permission) => boolean {
  const me = useContext(MeContext);
  return (permission) => (me ? canWith(me, permission) : false);
}
